import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appInputNumberMaxLength]',
})
export class InputNumberMaxLengthDirective {
  @Input() appInputNumberMaxLength = 1;

  // @HostListener('keyup', ['$event']) onKeyUp(e: KeyboardEvent) {
  @HostListener('input', ['$event']) onInput(e: KeyboardEvent) {
    const input = e.target as HTMLInputElement;
    const inputLength = input.value.length;

    if (inputLength && inputLength > this.appInputNumberMaxLength) {
      input.value = input.value.slice(0, this.appInputNumberMaxLength);
    }
  }
}
